module.exports = __webpack_public_path__ + "img/zb.e9152d9d.svg";